import { DamageType, TranslationObject } from '@monkvision/types';

/**
 * The translated labels for each damage type available in the SDK.
 */
export const damageTypeLabels: Record<DamageType, TranslationObject> = {
  [DamageType.SCRATCH]: {
    en: 'Scratch',
    fi: 'Halkeama',
    cs: 'Škrábanec',
    no: 'Ripe',
    ro: 'Zgârietură',
    pl: 'Zarysowanie',
    da: 'Ridse',
    sv: 'Repa',
    es: 'Arañazo',
    pt: 'Arranhão',
    fr: 'Rayure',
    de: 'Kratzer',
    nl: 'Kras',
    it: 'Graffio',
  },
  [DamageType.DENT]: {
    en: 'Dent',
    fi: 'Halkeama',
    cs: 'Promáčklina',
    no: 'Bulk',
    ro: 'Avarie',
    pl: 'Wgniecenie',
    da: 'bul',
    sv: 'buckla',
    es: 'Abolladura',
    pt: 'Amassado',
    fr: 'Bosse',
    de: 'Beule',
    nl: 'Deuk',
    it: 'Dente',
  },
  [DamageType.BROKEN_GLASS]: {
    en: 'Broken Glass',
    fi: 'Rikkoutunut lasi',
    cs: 'Rozbité sklo',
    no: 'Knust glass',
    ro: 'Parbriz spart',
    pl: 'Pęknięta szyba',
    da: 'Knust glas',
    sv: 'Trasigt glas',
    es: 'Vidrio roto',
    pt: 'Vidro Quebrado',
    fr: 'Bris de glace',
    de: 'Zerbrochenes Glas',
    nl: 'Gebroken glas',
    it: 'Vetro rotto',
  },
  [DamageType.BROKEN_LIGHT]: {
    en: 'Broken Light',
    fi: 'Vialla oleva valo',
    cs: 'Rozbité světlo',
    no: 'Ødelagt lys',
    ro: 'Lumină defectă',
    pl: 'Uszkodzone światło',
    da: 'Defekt lygte',
    sv: 'Trasigt ljus',
    es: 'Luz rota',
    pt: 'Luz Quebrada',
    fr: 'Feu cassé',
    de: 'Kaputtem Licht',
    nl: 'Gebroken licht',
    it: 'Luce rotta',
  },
  [DamageType.HUBCAP_SCRATCH]: {
    en: 'Hubcap Scratch',
    fi: 'Vanteen naarmu',
    cs: 'Škrábanec na poklici',
    no: 'Ripe på hjulkapsel',
    ro: 'Zgârietură pe capacul roții',
    pl: 'Zarysowanie kołpaka',
    da: 'Dækhætte-ridse',
    sv: 'Navkapsrepa',
    es: 'Arañazo en la tapacubos',
    pt: 'Arranhão na calota',
    fr: 'Enjoliveur rayé',
    de: 'Zerkratzte Radkappe',
    nl: 'Gebroken wieldop',
    it: 'Cerchione graffiato',
  },
  [DamageType.MISSING_HUBCAP]: {
    en: 'Missing Hubcap',
    fi: 'Puuttuva pyöränpultin suojus',
    cs: 'Chybějící poklice',
    no: 'Manglende hjulkapsel',
    ro: 'Capac de roată lipsă',
    pl: 'Brak kołpaka',
    da: 'Manglende hjulkapsel',
    sv: 'Saknad navkapsel',
    es: 'Tapa de rueda faltante',
    pt: 'Calota ausente',
    fr: 'Enjoliveur manquant',
    de: 'Fehlende Radkappe',
    nl: 'Ontbrekende wieldop',
    it: 'Cerchione mancante',
  },
  [DamageType.SMASH]: {
    en: 'Smash',
    fi: 'Poista',
    cs: 'Náraz',
    no: 'Kollisjonsskade',
    ro: 'Lovitură',
    pl: 'Zniszcz',
    da: 'Smadr',
    sv: 'Krasch',
    es: 'Aplastar',
    pt: 'Esmague',
    fr: 'Collision',
    de: 'Zusammenstoß',
    nl: 'Botsing',
    it: 'Collisione',
  },
  [DamageType.BODY_CRACK]: {
    en: 'Body Crack',
    fi: 'Halkeama rungossa',
    cs: 'Prasklina karoserie',
    no: 'Sprekk i karosseri',
    ro: 'Fisură în caroserie',
    pl: 'Pęknięcie nadwozia',
    da: 'Karosserirevne',
    sv: 'Karosspricka',
    es: 'Grieta en la carrocería',
    pt: 'Rachadura na carroceria',
    fr: 'Fissure dans la carrosserie',
    de: 'Karosserieriss',
    nl: 'Carrosseriescheur',
    it: 'Fessura della carrozzeria',
  },
  [DamageType.MISSING_PIECE]: {
    en: 'Missing Piece',
    fi: 'Puuttuva osa',
    cs: 'Chybějící díl',
    no: 'Manglende del',
    ro: 'Piesă lipsă',
    pl: 'Brakujący element',
    da: 'Manglende del',
    sv: 'Saknas',
    es: 'Pieza faltante',
    pt: 'Peça ausente',
    fr: 'Pièce manquante',
    de: 'Fehlendes Teil',
    nl: 'Ontbrekend onderdeel',
    it: 'Pezzo mancante',
  },
  [DamageType.RUSTINESS]: {
    en: 'Rustiness',
    fi: 'Ruostuminen',
    cs: 'Rez',
    no: 'Rust',
    ro: 'Rugină',
    pl: 'Korozja',
    da: 'Rust',
    sv: 'Rost',
    es: 'Oxidación',
    pt: 'Corrosão',
    fr: 'Rouille',
    de: 'Rostigkeit',
    nl: 'Roest',
    it: 'Ruggine',
  },
  [DamageType.DIRT]: {
    en: 'Dirt',
    fi: 'Likainen',
    cs: 'Nečistota',
    no: 'Skitt',
    ro: 'Murdărie',
    pl: 'Brud',
    da: 'Snavs',
    sv: 'smuts',
    es: 'Suciedad',
    pt: 'Sujeira',
    fr: 'Saleté',
    de: 'Dreck',
    nl: 'Vuil',
    it: 'Sporco',
  },
  [DamageType.MISSHAPE]: {
    en: 'Misshape',
    fi: 'Vääristynyt',
    cs: 'Deformace',
    no: 'Deformering',
    ro: 'Deformare',
    pl: 'Deformacja',
    da: 'Deformation',
    sv: 'missformning',
    es: 'Deformación',
    pt: 'Deformação',
    fr: 'Forme irrégulière',
    de: 'Fehlform',
    nl: 'Misvorm',
    it: 'Deformazione',
  },
  [DamageType.PAINT_PEELING]: {
    en: 'Paint Peeling',
    fi: 'Läikikö maali',
    cs: 'Odlupování laku',
    no: 'Avflassing av lakk',
    ro: 'Desprinderea vopselei',
    pl: 'Łuszcząca się farba',
    da: 'Afskallet maling',
    sv: 'Färgflagar',
    es: 'Desprendimiento de pintura',
    pt: 'Descascamento da tinta',
    fr: 'Peinture écaillée',
    de: 'Abblätternde Farbe',
    nl: 'Afbladderende verf',
    it: 'Vernice che si sfalda',
  },
  [DamageType.SCATTERED_SCRATCHES]: {
    en: 'Scattered Scratches',
    fi: 'Pienet naarmut',
    cs: 'Roztroušené škrábance',
    no: 'Spredte riper',
    ro: 'Zgârieturi împrăștiate',
    pl: 'Rozproszone rysy',
    da: 'Spredte ridser',
    sv: 'Spridda repor',
    es: 'Arañazos dispersos',
    pt: 'Arranhões dispersos',
    fr: 'Rayures éparses',
    de: 'Verstreute Kratzer',
    nl: 'Verspreide krassen',
    it: 'Grazze sparse',
  },
  [DamageType.LIGHT_REFLECTION]: {
    en: 'Light Reflection',
    fi: 'Valon heijastus',
    cs: 'Odraz světla',
    no: 'Lysrefleks',
    ro: 'Reflecția luminii',
    pl: 'Odbicie światła',
    da: 'Lysrefleks',
    sv: 'Ljusreflektion',
    es: 'Reflejo de luz',
    pt: 'Reflexo de luz',
    fr: 'Réflexion de la lumière',
    de: 'Lichtreflexion',
    nl: 'Licht Reflectie',
    it: 'Riflesso di luce',
  },
  [DamageType.SHADOW]: {
    en: 'Shadow',
    fi: 'Varjo',
    cs: 'Stín',
    no: 'Skygge',
    ro: 'Umbră',
    pl: 'Cień',
    da: 'Skygge',
    sv: 'Skugga',
    es: 'Sombra',
    pt: 'Sombra',
    fr: 'Ombre',
    de: 'Schatten',
    nl: 'Schaduw',
    it: 'Ombra',
  },
  [DamageType.CAR_CURVE]: {
    en: 'Car Curve',
    fi: 'Auto, kaarevuus',
    cs: 'Křivka vozidla',
    no: 'Bilkurve',
    ro: 'Curba vehiculului',
    pl: 'Krzywa pojazdu',
    da: 'Bilkurve',
    sv: 'Bilkurva',
    es: 'Curva del vehículo',
    pt: 'Curva do carro',
    fr: 'Courbe de la voiture',
    de: 'Auto-Kurve',
    nl: 'Auto kromming',
    it: "Curva dell'auto",
  },
  [DamageType.PAINT_DAMAGE]: {
    en: 'Paint Damage',
    fi: 'Pohjamaalin vaurio',
    cs: 'Poškození laku',
    no: 'Lakkskade',
    ro: 'Deteriorări ale vopselei',
    pl: 'Uszkodzenie lakieru',
    da: 'Lakskade',
    sv: 'Lackskada',
    es: 'Daños en la pintura',
    pt: 'Danos na Pintura',
    fr: 'Dégât sur la peinture',
    de: 'Lackschäden',
    nl: 'Beschadigde verf',
    it: 'Danno alla vernice',
  },
};
